import React, { useState } from "react";
import Footer from "../components/Shared/Footer";

const FAQSection = () => {
  const [activeQuestion, setActiveQuestion] = useState(1);

  const toggleQuestion = (questionNumber) => {
    setActiveQuestion((prev) =>
      prev === questionNumber ? null : questionNumber
    );
  };

  return (
    <div>

      <section className="breadcrumb-section pt-0">
      <div className="container-fluid-lg">
          <div className="row">
              <div className="col-12">
                  <div className="breadcrumb-contain">
                      <h2>FAQ</h2>
                      <nav>
                          <ol className="breadcrumb mb-0">
                              <li className="breadcrumb-item">
                                  <a href="/">
                                      <i className="fa-solid fa-house"></i>
                                  </a>
                              </li>
                              <li className="breadcrumb-item active">FAQ</li>
                          </ol>
                      </nav>
                  </div>
              </div>
          </div>
      </div>
      </section>
      <section className="fresh-vegetable-section section-lg-space">
        <div className="container-fluid-lg">
          <div className="row">
            <div className="col-xl-12 d-flex align-items-center justify-content-center">
              <div>
                {/* Question 1 */}
                <div className="line-card-one">
                  <div
                    className={`question ${activeQuestion === 1 ? "colo-active-obesity" : ""
                      }`}
                    onClick={() => toggleQuestion(1)}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      cursor: "pointer",
                      alignItems: "center",
                      transition: "color 0.3s ease",
                    }}
                  >
                    <span className="font-smd">1{")"} What does it contain?</span>
                    <i
                      className="fas fa-chevron-down font-smd"
                      style={{
                        transform:
                          activeQuestion === 1 ? "rotate(180deg)" : "rotate(0deg)",
                        transition: "transform 0.4s ease",
                      }}
                    ></i>
                  </div>
                  <div
                    className="answer font-xsm"
                    style={{
                      maxHeight: activeQuestion === 1 ? "600px" : "0",
                      overflow: "hidden",
                      transition: "max-height 0.8s cubic-bezier(0.25, 0.8, 0.25, 1)",
                      textAlign: "justify"
                    }}
                  >
                    <p className="font-xsm">
                    Healthy carbohydrates, high fibre, dual blend of proteins and heart friendly fat blend. 
                    It has gender specific vitamin and mineral mix 
                    as males and females have different Recommended Daily Allowances (RDAs) for key micronutrients. 
                    </p>
                  </div>
                </div>

                {/* Question 2 */}
                <div className="line-card-one">
                  <div
                    className={`question ${activeQuestion === 2 ? "colo-active-obesity" : ""
                      }`}
                    onClick={() => toggleQuestion(2)}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      cursor: "pointer",
                      alignItems: "center",
                      transition: "color 0.3s ease",
                    }}
                  >
                    <span className="font-smd">
                      2{")"} Who will benefit from Reducarb?
                    </span>
                    <i
                      className="fas fa-chevron-down font-smd"
                      style={{
                        transform:
                          activeQuestion === 2 ? "rotate(180deg)" : "rotate(0deg)",
                        transition: "transform 0.4s ease",
                      }}
                    ></i>
                  </div>
                  <div
                    className="answer font-xsm"
                    style={{
                      maxHeight: activeQuestion === 2 ? "1000px" : "0",
                      overflow: "hidden",
                      transition: "max-height 0.8s cubic-bezier(0.25, 0.8, 0.25, 1)",
                      textAlign: "justify"
                    }}
                  >
                    <div className="font-md">
                      <div className="custom-list-effectonhealth mb-2  text-muted ">
                        <div className=" custom-list-item-height-two font-xsm" style={{ textAlign: "justify" }}>
                          Reducarb will benefit people with:
                        </div>

                        <div className="custom-list-item-height-two font-xsm" style={{ textAlign: "justify" }}>
                          <span className="me-2">A)</span>
                          <span className="fw-semibold">Abdominal obesity - </span>
                          Do I have abdominal obesity? - For that you need to find your waist circumference.

                          Find the bottom of your ribs and the top of your hips (usually at your navel). Wrap a tape measure around your belly at the halfway point between them
                          (just above the belly button). Make sure it is pulled tight but isn't digging into 
                          your skin. Breathe out naturally and make a note of where the tape measure reaches 
                          all the way around. The abdominal obesity has been defined as waist circumference of 
                          more than 80 cm in women and of more than 94 cm in men. <br/>
                          Please scan the QR code on the pack & calculate your risk profile, assessments and know more about it.

                        </div>
                        <div className="custom-list-item-height-two font-xsm" style={{ textAlign: "justify" }}>
                          <span className="me-2">B)</span>
                          <span className="fw-semibold">Pre-diabetes - </span>
                          What is Pre-diabetes? - Fasting glucose values of 110-125 mg/dl and/or HbA1c between 5.7 to 6.4%
                          <br/>
                          Please scan the QR code on the pack & calculate your risk profile, assessments and know more about it.
                        </div>
                        <div className="custom-list-item-height-two font-xsm" style={{ textAlign: "justify" }}>
                          <span className="me-2">C)</span>
                          <span className="fw-semibold">Overweight and/or Obesity - </span>
                          Am I an overweight or obese? - You are overweight if your Body Mass Index (BMI) greater than or equal to 25 kg/m<sup>2</sup> or obese if a BMI greater than or equal to 30 kg/m<sup>2</sup>  
                          (BMI calculation - weight in kg/ (height in meter)<sup>2</sup>).
                          <br/>
                          Please scan the QR code on the pack & calculate your risk profile, assessments and know more about it.
                        </div>
                        <div className="custom-list-item-height-two font-xsm" style={{ textAlign: "justify" }}>
                          <span className="me-2">D)</span>
                          <span className="fw-semibold">Risk of diabetes or heart diseases - </span>
                          Do I have risk profile for diabetes or heart disease?
                          If three or more of the following five criteria are met:
                          A) waist circumference over 94 cm (men) or 80 cm (women),
                          B) blood pressure over 130/85 mmHg,
                          C) triglyceride (TG) lipids level over 150 mg/dl,
                          D) high-density lipoprotein (HDL) cholesterol level less than 40 mg/dl (men) or 50 mg/dl (women) and
                          E) fasting blood sugar over 100 mg/dl
                          <br/>
                          Please scan the QR code on the pack & calculate your risk profile, assessments and know more about it.
                        </div>
                        <div className="custom-list-item-height-two font-xsm" style={{ textAlign: "justify" }}>
                          <span className="me-2">E)</span>
                          <span className="fw-semibold">Wish to reduce their daily carbohydrate intake - </span>
                          Should I consider reducing my carbohydrates?
                          If you are having unhealthy dietary habits (excess calories, junk foods, carbohydrate rich ('sugary' foods or refined sugars), high fat, salt and sugar
                          containing processed foods, irregular meals or meal timings and your daily
                          carbohydrate intake is more than 130gm /day*) and want to reduce calories
                          and /or carbohydrates. (*consult your dietician for calculating carbohydrate
                          intake)
                          <br/>
                          Please scan the QR code on the pack and know more about it.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Question 3 */}
                <div className="line-card-one">
                  <div
                    className={`question ${activeQuestion === 3 ? "colo-active-obesity" : ""
                      }`}
                    onClick={() => toggleQuestion(3)}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      cursor: "pointer",
                      alignItems: "center",
                      transition: "color 0.3s ease",
                    }}
                  >
                    <span className="font-smd">
                      3)	Why Reducarb has separate variants for male and female?
                    </span>
                    <i
                      className="fas fa-chevron-down font-smd"
                      style={{
                        transform:
                          activeQuestion === 3 ? "rotate(180deg)" : "rotate(0deg)",
                        transition: "transform 0.4s ease",
                      }}
                    ></i>
                  </div>
                  <div
                    className="answer font-xsm"
                    style={{
                      maxHeight: activeQuestion === 3 ? "600px" : "0",
                      overflow: "hidden",
                      transition: "max-height 0.8s cubic-bezier(0.25, 0.8, 0.25, 1)",
                      textAlign: "justify"
                    }}
                  >
                    <p className="font-xsm">
                    Male and females differ in terms of calorie requirements, added sugar allowance, fibre and protein requirements. Their Recommended Daily
                    Allowances of key micronutrients (vitamins & minerals) also differ.
                    </p>
                    <p className="font-xsm" style={{ textAlign: "justify" }}>  
                    Further, they respond differently to nutrition based on their hormonal and metabolic needs.
                    </p>
                    <p className="font-xsm" style={{ textAlign: "justify" }}>  
                    Considering, different requirement, RDAs and body response, Reducarb has two separate variants.
                    </p>
                  </div>
                </div>

                {/* Question 4 */}
                <div className="line-card-one">
                  <div
                    className={`question ${activeQuestion === 4 ? "colo-active-obesity" : ""
                      }`}
                    onClick={() => toggleQuestion(4)}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      cursor: "pointer",
                      alignItems: "center",
                      transition: "color 0.3s ease",
                    }}
                  >
                    <span className="font-smd">
                      4)	How should I start Reducarb meal replacement plan?
                    </span>
                    <i
                      className="fas fa-chevron-down font-smd"
                      style={{
                        transform:
                          activeQuestion === 4 ? "rotate(180deg)" : "rotate(0deg)",
                        transition: "transform 0.4s ease",
                      }}
                    ></i>
                  </div>
                  <div
                    className="answer font-xsm"
                    style={{
                      maxHeight: activeQuestion === 4 ? "1200px" : "0",
                      overflow: "hidden",
                      transition: "max-height 0.8s cubic-bezier(0.25, 0.8, 0.25, 1)",
                      textAlign: "justify"
                    }}
                  >
                    <p className="font-xsm">
                      A) Many people want to try a low-carbohydrate eating pattern for various reasons. It is based on individual daily schedule, objective of meal replacement and health targets. 
                    </p>
                    <p className="font-xsm">
                      B) Gather all required information. Visit www.mycarb-reducarb.com
                    </p>
                    <p className="font-xsm">
                      C) You may take dietary, physical activity and food related psychology assessments on our website
                    </p>
                    <p className="font-xsm">
                      D) Decide on the meal to be replaced based on your lifestyle preference  
                    </p>
                    <p className="font-xsm">
                      E) Prepare you mind for a change 
                    </p>
                    <p className="font-xsm">
                      F) Decide a date for first meal replacement
                    </p>
                    <p className="font-xsm">
                      G) On that day, follow the instruction for reconstitution and consumption
                    </p>
                    <p className="font-xsm">
                      H) Please note, ReducarbTM taste best at with 150 ml water. Hence, add exact 150 ml of water. Too much or too little water may spoil the taste. You may drink additional water after your meal. 
                    </p>
                    <p className="font-xsm">
                      I) Now replace your meal with Reducarb
                    </p>
                    <p className="font-xsm">
                      J) You may feel half-filled or get hunger pangs even after meal for few initial days 
                    </p>
                    <p className="font-xsm">
                      K) You may eat supplementary food like veg salads, leafy vegetable serving, fruits for first few days till you adjust to new routine. You may not need it thereafter 
                    </p>
                    <p className="font-xsm">
                      L) Be patient and gradual in approach BUT be consistent 
                    </p>
                    <p className="font-xsm">
                      M) You may feel bloating, fullness, abdominal discomfort for first 2-3 days. Don’t rush and have it slowly
                    </p>
                    <p className="font-xsm">
                      N) Though most people adjust to changed meal pattern, some may take some time. 
                    </p>
                    <p className="font-xsm">
                      O) Most of the patient adjust to new dietary practise in 1 week
                    </p>
                    <p className="font-xsm">
                      P) You will start feeling light, full of energy and active thereafter
                    </p>
                    <p className="font-xsm">
                      Q) Undergo various Assessments available on www.mycarb-reducarb.com
                    </p>
                    <p className="font-xsm">
                      R) Your reports would help to monitor your progress
                    </p>
                    <p className="font-xsm">
                      S) You may consult our Expert panel OR your dietician / Doctor
                    </p>
                  </div>
                </div>

                {/* Question 5 */}
                {/* <div className="line-card-one">
                  <div
                    className={`question ${activeQuestion === 5 ? "colo-active-obesity" : ""
                      }`}
                    onClick={() => toggleQuestion(5)}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      cursor: "pointer",
                      alignItems: "center",
                      transition: "color 0.3s ease",
                    }}
                  >
                    <span className="font-smd">
                      5)	What precautions should I take while on Reducarb?
                    </span>
                    <i
                      className="fas fa-chevron-down font-smd"
                      style={{
                        transform:
                          activeQuestion === 5 ? "rotate(180deg)" : "rotate(0deg)",
                        transition: "transform 0.4s ease",
                      }}
                    ></i>
                  </div>
                  <div
                    className="answer font-xsm"
                    style={{
                      maxHeight: activeQuestion === 5 ? "800px" : "0",
                      overflow: "hidden",
                      transition: "max-height 0.8s cubic-bezier(0.25, 0.8, 0.25, 1)",
                      textAlign: "justify"
                    }}
                  >
                    <p className="font-xsm">
                    Reducarb is a low carbohydrate meal plan with high fibre and proteins. It is
  helpful in reducing weight, abdominal obesity (fat), blood sugars and lipids.
  Following are precautions one should take while initiation and maintenance
  on Reducarb diet plan:
                    </p>
                    <div className="font-md">
                      <div className="custom-list-effectonhealth mb-2  text-muted ">

                        <div className="custom-list-item-height-two font-xsm" style={{ textAlign: "justify" }}>
                          <span className="me-2">A)</span>
                          Know your calorie and carbohydrate intake With diet recall.
                        </div>
                        <div className="custom-list-item-height-two font-xsm" style={{ textAlign: "justify" }}>
                          <span className="me-2">B)</span>
                          You may consult a dietician or healthcare personnel to plan your meal replacement.
                        </div>
                        <div className="custom-list-item-height-two font-xsm" style={{ textAlign: "justify" }}>
                          <span className="me-2">C)</span>
                          Follow instructions for reconstitution and consumption.
                        </div>
                        <div className="custom-list-item-height-two font-xsm" style={{ textAlign: "justify" }}>
                          <span className="me-2">D)</span>
                          Adjusting to new meal routine takes time. Be patient and consistent.
                        </div>
                        <div className="custom-list-item-height-two font-xsm" style={{ textAlign: "justify" }}>
                          <span className="me-2">E)</span>
                          You may need to consult your dietician / healthcare personnel for 'rescue' food in case of hunger pangs.
                        </div>
                        <div className="custom-list-item-height-two font-xsm" style={{ textAlign: "justify" }}>
                          <span className="me-2">F)</span>
                          It is usually well tolerated, however you may feel bloating, fullness, abdominal discomfort during initial period. You may adjust your intake gradually.
                        </div>
                        <div className="custom-list-item-height-two font-xsm" style={{ textAlign: "justify" }}>
                          <span className="me-2">G)</span>
                          You may consult our Experts or your dietician / healthcare personnel for any concomitant health condition
                        </div>

                      </div>
                    </div>
                  </div>
                </div> */}

                {/* Question 6 */}
                <div className="line-card-one">
                  <div
                    className={`question ${activeQuestion === 5 ? "colo-active-obesity" : ""
                      }`}
                    onClick={() => toggleQuestion(5)}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      cursor: "pointer",
                      alignItems: "center",
                      transition: "color 0.3s ease",
                    }}
                  >
                    <span className="font-smd">
                      5)	Is it safe? What are side effects?
                    </span>
                    <i
                      className="fas fa-chevron-down font-smd"
                      style={{
                        transform:
                          activeQuestion === 6 ? "rotate(180deg)" : "rotate(0deg)",
                        transition: "transform 0.4s ease",
                      }}
                    ></i>
                  </div>
                  <div
                    className="answer font-xsm"
                    style={{
                      maxHeight: activeQuestion === 5 ? "600px" : "0",
                      overflow: "hidden",
                      transition: "max-height 0.8s cubic-bezier(0.25, 0.8, 0.25, 1)",
                      textAlign: "justify"
                    }}
                  >
                    <p className="font-xsm">
                    Reducarb is NOT a ketogenic diet. Reducarb may be used only for one or more meal replacement and not for all meals 
                    of the day. Generally moderately low carbohydrate approach is well tolerated. 
                    Some vitamin and mineral deficiencies may happen during long term replacement protocols. 
                    However, Reducarb is enriched with key vitamins upto 50% of RDAs. 
                    Some people may face breakthrough hungers, bloating, fullness, abdominal discomfort, fatigue, weakness during initial period. 
                    Generally, tolerance improves over time. 
                    Please consult our Experts or your dietician / Doctor in case of problems/ side effects persist. 
                    </p>
                  </div>
                </div>
                {/* Question 6 */}
                <div className="line-card-one">
                  <div
                    className={`question ${activeQuestion === 6 ? "colo-active-obesity" : ""}`}
                    onClick={() => toggleQuestion(6)}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      cursor: "pointer",
                      alignItems: "center",
                      transition: "color 0.3s ease",
                    }}
                  >
                    <span className="font-smd">
                      6)	Will it cause excessive drowsiness post meal? 
                    </span>
                    <i
                      className="fas fa-chevron-down font-smd"
                      style={{
                        transform:
                          activeQuestion === 7 ? "rotate(180deg)" : "rotate(0deg)",
                        transition: "transform 0.4s ease",
                      }}
                    ></i>
                  </div>
                  <div
                    className="answer font-xsm"
                    style={{
                      maxHeight: activeQuestion === 6 ? "600px" : "0",
                      overflow: "hidden",
                      transition: "max-height 0.8s cubic-bezier(0.25, 0.8, 0.25, 1)",
                      textAlign: "justify"
                    }}
                  >
                    <p className="font-xsm">
                    Reducarb is a low carbohydrate, high fibre and protein meal plan. Diet rich in proteins 
                    ({'>'}20 % calories from proteins) 
                    are shown to cause less post meal drowsiness (compared to diets with high carbohydrates). 
                    </p>
                  </div>
                </div>
                {/* Question 7 */}
                <div className="line-card-one">
                  <div
                    className={`question ${activeQuestion === 7 ? "colo-active-obesity" : ""}`}
                    onClick={() => toggleQuestion(7)}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      cursor: "pointer",
                      alignItems: "center",
                      transition: "color 0.3s ease",
                    }}
                  >
                    <span className="font-smd">
                      7) How to handle Reducarb pack?
                    </span>
                    <i
                      className="fas fa-chevron-down font-smd"
                      style={{
                        transform:
                          activeQuestion === 7 ? "rotate(180deg)" : "rotate(0deg)",
                        transition: "transform 0.4s ease",
                      }}
                    ></i>
                  </div>
                  <div
                    className="answer font-xsm"
                    style={{
                      maxHeight: activeQuestion === 7 ? "600px" : "0",
                      overflow: "hidden",
                      transition: "max-height 0.8s cubic-bezier(0.25, 0.8, 0.25, 1)",
                      textAlign: "justify"
                    }}
                  >
                    <p className="font-xsm">
                      A) Check the validity (expiry date)
                    </p>
                    <p className="font-xsm">
                      B) Ensure it is sealed and not tampered
                    </p>
                    <p className="font-xsm">
                      C) Remove the inner foil pack and check for its seal
                    </p>
                    <p className="font-xsm">
                      D) Check for the scoop
                    </p>
                    <p className="font-xsm">
                      E) Cut the foil pack horizontally and completely
                    </p>
                    <p className="font-xsm">
                      F) Use the scoop to make the meal
                    </p>
                    <p className="font-xsm">
                      G) Keep the scoop inside the pack and seal it airtight
                    </p>
                    <p className="font-xsm">
                      H) You may keep the foil pack and scoop in a clean and dry air tight container
                    </p>
                    <p className="font-xsm">
                      I) Store it in cool and dry place
                    </p>
                    <p className="font-xsm">
                      J) Discard it appropriately after use
                    </p>
                  </div>
                </div>
                {/* Question 9 */}
                <div className="line-card-one">
                  <div
                    className={`question ${activeQuestion === 8 ? "colo-active-obesity" : ""}`}
                    onClick={() => toggleQuestion(8)}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      cursor: "pointer",
                      alignItems: "center",
                      transition: "color 0.3s ease",
                    }}
                  >
                    <span className="font-smd">
                      8) What should I expect from Reducarb ?
                    </span>
                    <i
                      className="fas fa-chevron-down font-smd"
                      style={{
                        transform:
                          activeQuestion === 8 ? "rotate(180deg)" : "rotate(0deg)",
                        transition: "transform 0.4s ease",
                      }}
                    ></i>
                  </div>
                  <div
                    className="answer font-xsm"
                    style={{
                      maxHeight: activeQuestion === 8 ? "600px" : "0",
                      overflow: "hidden",
                      transition: "max-height 0.8s cubic-bezier(0.25, 0.8, 0.25, 1)",
                      textAlign: "justify"
                    }}
                  >
                    <p className="font-xsm">
                    Reducing daily carbohydrate with Reducarb meal replacement regime along with 
                    active lifestyle & regular exercise will support:
                    </p>
                    <p className="font-xsm">
                      A) Reversal or halting progression of pre-diabetes 
                    </p>
                    <p className="font-xsm">
                      B) Reversal of underlying insulin resistance, if any
                    </p>
                    <p className="font-xsm">
                      C) Reduction in the risk of diabetes, high lipids and high blood pressure
                    </p>
                    <p className="font-xsm">
                      D) Reduction in weight and maintaining it for long time
                    </p>
                    <p className="font-xsm">
                      E) Active lifestyle with enthusiastic and energetic feel  
                    </p>
                    <p className="font-xsm">
                      F) Reduction in lethargy, sleepiness and heaviness
                    </p>
                  </div>
                </div>
                <div className="line-card-one">
                  <div
                    className={`question ${activeQuestion === 9 ? "colo-active-obesity" : ""}`}
                    onClick={() => toggleQuestion(9)}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      cursor: "pointer",
                      alignItems: "center",
                      transition: "color 0.3s ease",
                    }}
                  >
                    <span className="font-smd">
                      9) I am a working woman. How will I carry it to may work place for lunch replacement?
                    </span>
                    <i
                      className="fas fa-chevron-down font-smd"
                      style={{
                        transform:
                          activeQuestion === 9 ? "rotate(180deg)" : "rotate(0deg)",
                        transition: "transform 0.4s ease",
                      }}
                    ></i>
                  </div>
                  <div
                    className="answer font-xsm"
                    style={{
                      maxHeight: activeQuestion === 9 ? "600px" : "0",
                      overflow: "hidden",
                      transition: "max-height 0.8s cubic-bezier(0.25, 0.8, 0.25, 1)",
                      textAlign: "justify"
                    }}
                  >
                    <p className="font-xsm">
                    You may keep Reducarb pack and a shaker / tumbler at your office in a cool and dry secure place. 
                    Or you may carry 60 g (2 scoops) in a dry shaker / tumblers with you & add 150 ml water at lunch time and prepare your drink. 
                    Please follow all instruction for preparation and storage  
                    </p>
                    
                  </div>
                </div>

                <div className="line-card-one">
                  <div
                    className={`question ${activeQuestion === 10 ? "colo-active-obesity" : ""}`}
                    onClick={() => toggleQuestion(10)}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      cursor: "pointer",
                      alignItems: "center",
                      transition: "color 0.3s ease",
                    }}
                  >
                    <span className="font-smd">
                     10)	I am having lactose intolerance. Can I have Reducarb ?
                    </span>
                    <i
                      className="fas fa-chevron-down font-smd"
                      style={{
                        transform:
                          activeQuestion === 10 ? "rotate(180deg)" : "rotate(0deg)",
                        transition: "transform 0.4s ease",
                      }}
                    ></i>
                  </div>
                  <div
                    className="answer font-xsm"
                    style={{
                      maxHeight: activeQuestion === 10 ? "600px" : "0",
                      overflow: "hidden",
                      transition: "max-height 0.8s cubic-bezier(0.25, 0.8, 0.25, 1)",
                      textAlign: "justify"
                    }}
                  >
                    <p className="font-xsm">
                    The protein source of Reducarb is whey protein isolate. 
                    Whey protein isolate contains lactose, but in significantly lower amounts compared to whey protein concentrate, 
                    making it a better option for many individuals with lactose intolerance
                    </p>
                    
                  </div>
                </div>


                {/* copied */}
                <div className="line-card-one">
                  <div
                    className={`question ${activeQuestion === 11 ? "colo-active-obesity" : ""}`}
                    onClick={() => toggleQuestion(11)}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      cursor: "pointer",
                      alignItems: "center",
                      transition: "color 0.3s ease",
                    }}
                  >
                    <span className="font-smd">
                    11)	I am diabetic patient. Can I have Reducarb?
                    </span>
                    <i
                      className="fas fa-chevron-down font-smd"
                      style={{
                        transform:
                          activeQuestion === 11 ? "rotate(180deg)" : "rotate(0deg)",
                        transition: "transform 0.4s ease",
                      }}
                    ></i>
                  </div>
                  <div
                    className="answer font-xsm"
                    style={{
                      maxHeight: activeQuestion === 11 ? "600px" : "0",
                      overflow: "hidden",
                      transition: "max-height 0.8s cubic-bezier(0.25, 0.8, 0.25, 1)",
                      textAlign: "justify"
                    }}
                  >
                    <p className="font-xsm">
                    Yes. Low carbohydrate, high fiber and high protein diet plans are recommended in obese Diabetic patients for 
                    weight reduction, reversal of insulin resistance and/or reduction of high sugars. They also benefit it reucing antidiabetic 
                    medications. 
                    Please consult our Medical experts or your Doctor to check whether you are suitable for Reducarb diet plan 
                    </p>
                    
                  </div>
                </div>

                <div className="line-card-one">
                  <div
                    className={`question ${activeQuestion === 12 ? "colo-active-obesity" : ""}`}
                    onClick={() => toggleQuestion(12)}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      cursor: "pointer",
                      alignItems: "center",
                      transition: "color 0.3s ease",
                    }}
                  >
                    <span className="font-smd">
                    12)	I am having high blood pressure. Can I have Reducarb?
                    </span>
                    <i
                      className="fas fa-chevron-down font-smd"
                      style={{
                        transform:
                          activeQuestion === 12 ? "rotate(180deg)" : "rotate(0deg)",
                        transition: "transform 0.4s ease",
                      }}
                    ></i>
                  </div>
                  <div
                    className="answer font-xsm"
                    style={{
                      maxHeight: activeQuestion === 12 ? "600px" : "0",
                      overflow: "hidden",
                      transition: "max-height 0.8s cubic-bezier(0.25, 0.8, 0.25, 1)",
                      textAlign: "justify"
                    }}
                  >
                    <p className="font-xsm">
                    Yes. Low carbohydrate, high fiber and high protein diet plans are recommended in 
                    patients with high blood pressure and high lipids / sugars. It is generally called at Metabolic syndrome. 
                    </p>
                    
                  </div>
                </div>

                <div className="line-card-one">
                  <div
                    className={`question ${activeQuestion === 13 ? "colo-active-obesity" : ""}`}
                    onClick={() => toggleQuestion(13)}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      cursor: "pointer",
                      alignItems: "center",
                      transition: "color 0.3s ease",
                    }}
                  >
                    <span className="font-smd">
                    13)	I am suffering from Polycystic Ovaries. Can I have Reducarb?
                    </span>
                    <i
                      className="fas fa-chevron-down font-smd"
                      style={{
                        transform:
                          activeQuestion === 13 ? "rotate(180deg)" : "rotate(0deg)",
                        transition: "transform 0.4s ease",
                      }}
                    ></i>
                  </div>
                  <div
                    className="answer font-xsm"
                    style={{
                      maxHeight: activeQuestion === 13 ? "600px" : "0",
                      overflow: "hidden",
                      transition: "max-height 0.8s cubic-bezier(0.25, 0.8, 0.25, 1)",
                      textAlign: "justify"
                    }}
                  >
                    <p className="font-xsm">
                    Yes. Polycystic Ovaries are generally due to stress and underlying insulin resistance. Low carbohydrate, 
                    high fiber and high protein diet plans are recommended to reduce insulin resistance in polycystic ovaries. 
                    </p>
                    
                  </div>
                </div>
                

              </div>
            </div>
          </div>
        </div>

      </section>

      <section className="fresh-vegetable-section section-lg-space">
  <div className="container-fluid-lg">
    <div className="review-title mb-3">
      <h1 className="font-lg mb-2">References:</h1>
    </div>
    <div className="references">
      <p><strong>1.</strong> <a  >Ref: www.thelancet.com Vol 14 July, 2023. https://doi.org/10. 1016/j.lansea.2023.
      100208</a></p>
      <p><strong>2.</strong> <a   >(Ref - Indian J Med Res 148, December 2018, pp 675-676 DOI:
10.4103/ijmr.IJMR_1785_18; https://www.mayoclinic.org/diseases-
conditions/prediabetes/diagnosis-treatment/drc-20355284)</a></p>
      <p><strong>3.</strong> <a   >(Ref: Journal of Obesity Volume 2023, Article ID 4178121, 13 pages
        https://doi.org/10.1155/2023/4178121)</a></p>
      <p><strong>4.</strong> <a   >(Ref - Disease Models &amp; Mechanisms 2, 231-237 (2009) doi:10.1242/dmm.001180)</a></p>
    </div>
  </div>
</section>
      <div>
          <Footer />
      </div>
    </div>
  );
};

export default FAQSection;
